import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Dropdown, List, Toast } from 'antd-mobile';
import { getSeriesCategories } from '../../services/services';
import { useFilesArgDispatch } from '../FilesArgContext';
import { CheckOutline } from 'antd-mobile-icons';
import styles from './index.module.css';
// import { useNavigate } from 'react-router-dom';
// import { FormattedMessage } from 'react-intl';

const TypeSeries = ({ activeTab }) => {
  // const navigate = useNavigate();
  const filesArgDispatch = useFilesArgDispatch();

  // 用于存储 Toast 句柄的引用
  const handler = useRef(null);

  // 状态定义：当前激活的分类和系列
  const [activeCategory, setActiveCategory] = useState({
    sequence: 0,
    name: '',
    id: '',
  });
  const [activeSeries, setActiveSeries] = useState({
    sequence: 0,
    name: '',
    id: '',
  });

  // 状态定义：分类列表和系列列表
  const [categories, setCategories] = useState([]);
  // const [onee, setonee] = useState();

  // 使用 useMemo 计算系列列表，避免不必要的重新计算
  const series = useMemo(() => {
    return (
      categories.length > 0 &&
      (categories[activeCategory.sequence].product_series || [])
    );
  }, [categories, activeCategory.sequence]);

  // 当系列列表或激活的系列发生变化时，更新文件参数

  useEffect(() => {
    if (series.length > 0 && series[activeSeries.sequence].entries.length > 0) {
      filesArgDispatch({
        type: 'changed',
        entries: series[activeSeries.sequence].entries,
        product_category: activeCategory.id,
        series_id: activeSeries.id,
      });
    } else {
      filesArgDispatch({
        type: 'changed',
        entries: [],
        product_category: '',
        series_id: '',
      });
    }
  }, [filesArgDispatch, series, activeSeries, activeCategory]);

  // 加载分类和系列列表
  useEffect(() => {
    let ignore = false;
    async function httpSeriesCategories() {
      // 显示加载提示
      handler.current = Toast.show({
        icon: 'loading',
        // content:  <FormattedMessage id="load" /> ,
        content: 'loading...',
        duration: 0,
      });
      const currentHashname = window.location.hash;
      const pathParts = currentHashname.split('/');
      const array = JSON.parse(localStorage.getItem('idArray'));
      console.log(pathParts[1], ' pathParts1');
      console.log(activeTab, ' activeTab');
      const isarray = array.findIndex(item => item === pathParts[1]);

      console.log(isarray, 'isarray');
      if (isarray >= 0) {
        // const onee = pathParts[1];
        if (activeTab === pathParts[1]) {
          console.log('aaaaaaaaaaaaaaaaaaaaaa');
        } else if (activeTab && activeTab !== pathParts[1]) {
          const currentHashname = window.location.hash;
          const pathParts = currentHashname.split('/');
          console.log(pathParts, 'pathParts');
          console.log(activeTab, 'activeTabactiveTab21111');
          const pathname = `#/${activeTab}`;
          console.log(pathname, 'pathname');
          console.log(pathParts[1], ' pathParts111111');
          window.location.href = pathname;
        } else {
          activeTab = pathParts[1];
          console.log(activeTab, 'und');
        }

        const res = await getSeriesCategories(activeTab);

        if (res.status === 200) {
          const result = res.result.product_categories.filter(
            item =>
              item.product_series && item.product_series.length > 0 && item.name
          );
          setCategories(result);
          console.log(result, 'resultresult');
          if (!ignore && result.length > 0) {
            const targetObject = result.find(item => item.id === pathParts[2]);
            const twoindex = result.findIndex(item => item.id === pathParts[2]);
            if (twoindex >= 0) {
              // 设置默认激活的分类和系列
              setActiveCategory({
                sequence: twoindex,
                name: targetObject?.name,
                id: targetObject?.id,
              });
            } else {
              setActiveCategory({
                sequence: 0,
                name: result[0]?.name,
                id: result[0]?.id,
              });
            }
            console.log(targetObject, 'targetObject');
            console.log(twoindex, 'twoindex');

            if (targetObject?.product_series.length > 0) {
              console.log(pathParts[2], 'three');
              const threeindex = targetObject.product_series.findIndex(
                item => item.id === pathParts[3]
              );
              if (threeindex >= 0) {
                setActiveSeries({
                  sequence: threeindex,
                  name: targetObject?.product_series[threeindex]?.name,
                  id: targetObject?.product_series[threeindex]?.id,
                });
                const currentHashname = window.location.hash;
                const pathParts = currentHashname.split('/');
                console.log(pathParts, 'pathParts');
                console.log(activeTab, 'activeTabactiveTab');
                const pathname = `#/${activeTab}/${targetObject?.id}/${targetObject?.product_series[threeindex]?.id}`;
                console.log(pathname, 'pathname');
                window.location.replace(pathname);
              } else {
                setActiveSeries({
                  sequence: 0,
                  name: targetObject?.product_series[0]?.name,
                  id: targetObject?.product_series[0]?.id,
                });
                const currentHashname = window.location.hash;
                const pathParts = currentHashname.split('/');
                console.log(pathParts, 'pathParts');
                console.log(activeTab, 'activeTabactiveTab');
                const pathname = `#/${activeTab}/${targetObject?.id}/${targetObject?.product_series[0]?.id}`;
                console.log(pathname, 'pathname');
                window.location.replace(pathname);
              }
              console.log(threeindex, 'threeindex');
            } else {
              setActiveSeries({
                sequence: 0,
                name: result[0]?.product_series[0]?.name,
                id: result[0]?.product_series[0]?.id,
              });
              const currentHashname = window.location.hash;
              const pathParts = currentHashname.split('/');
              console.log(pathParts, 'pathParts');
              console.log(activeTab, 'activeTabactiveTab');
              const pathname = `#/${activeTab}/${result[0]?.id}/${result[0]?.product_series[0]?.id}`;
              console.log(pathname, 'pathname');
              window.location.replace(pathname);
            }
            // 关闭加载提示
            handler.current.close();
          }
        } else {
          // 显示错误提示
          Toast.show({
            content: res.error,
            duration: 3000,
          });
        }
      } else {
        const res = await getSeriesCategories('EnterpriseNetwork');
        if (res.status === 200) {
          const result = res.result.product_categories;
          setCategories(result);
          console.log(result, 'resultresult');
          if (!ignore && result.length > 0) {
            setActiveCategory({
              sequence: 0,
              name: result[0]?.name,
              id: result[0]?.id,
            });
            if (result[0].product_series.length > 0) {
              setActiveSeries({
                sequence: 1,
                name: result[0]?.product_series[1]?.name,
                id: result[0]?.product_series[1]?.id,
              });
              const pathname = `#/${'EnterpriseNetwork'}/${result[0].id}/${
                result[0]?.product_series[1]?.id
              }`;
              console.log(pathname, 'pathname');
              window.location.replace(pathname);
            }
            const pathname = `#/${'EnterpriseNetwork'}/${result[0].id}/${
              result[0]?.product_series[1]?.id
            }`;
            console.log(pathname, 'pathname');
            window.location.replace(pathname);
            // 关闭加载提示
            handler.current.close();
          }
        } else {
          // 显示错误提示
          Toast.show({
            content: res.error,
            duration: 3000,
          });
        }
      }
      handler.current.close();
    }
    httpSeriesCategories();
    return () => {
      ignore = true;
    };
  }, [activeTab]);

  return (
    <div style={{ backgroundColor: '#F6F6F6' }}>
      {/* 下拉框组件 */}
      <Dropdown>

        {/* 分类下拉项 */}
        <Dropdown.Item
          key='product_categories'
          title={
            <div >
              {categories.length > 0 && activeCategory.name}
            </div>
          }
        >
          <List
            header=''
            style={{
              '--font-size': '3.59vw',
            }}
          >
            {categories.map((item, index) => {
              return (
                <List.Item
                  onClick={() => {
                    setActiveCategory({
                      sequence: index,
                      name: item.name,
                      id: item.id,
                    });
                    setActiveSeries({
                      sequence: 0,
                      name:
                        item.product_series.length > 0 &&
                        item.product_series[0].name,
                      id:
                        item.product_series.length > 0 &&
                        item.product_series[0].id,
                    });

                    const currentHashname = window.location.hash;
                    const pathParts = currentHashname.split('/');
                    console.log(pathParts, 'pathParts');
                    console.log(activeTab, 'activeTabactiveTab');

                    const pathname = `#/${activeTab}/${item.id}/${item.product_series[0].id}`;
                    console.log(pathname, 'pathname');
                    window.location.replace(pathname);
                  }}
                  className={
                    index === activeCategory.sequence && styles.activeColor
                  }
                  arrow={
                    index === activeCategory.sequence && (
                      <CheckOutline
                        color='#36a167'
                        fontSize={'5.385vw'}
                      />
                    )
                  }
                  key={index}
                >
                  {item.name}
                </List.Item>
              );
            })}
          </List>
        </Dropdown.Item>
        {/* 系列下拉项 */}

        <Dropdown.Item
          key='product_series'
          title={
            <div >
              {series.length > 0 && activeSeries.name}
            </div>
          }
        >
          <List
            header=''
            style={{ '--font-size': '3.59vw' }}
          >
            {series.length > 0 &&
              series.map((item, index) => {
                return (
                  <List.Item
                    onClick={() => {
                      setActiveSeries({
                        sequence: index,
                        name: item.name,
                        id: item.id,
                      });

                      const currentHashname = window.location.hash;
                      const pathParts = currentHashname.split('/');
                      const r1 = pathParts[1];
                      const r2 = pathParts[2];
                      const r3 = item.id;
                      const pathname = `#/${r1}/${r2}/${r3}`;
                      window.location.replace(pathname);
                    }}
                    key={index}
                    className={
                      index === activeSeries.sequence && styles.activeColor
                    }
                    arrow={
                      index === activeSeries.sequence && (
                        <CheckOutline
                          color='#36a167'
                          fontSize={'5.385vw'}
                        />
                      )
                    }
                  >
                    {item.name}
                  </List.Item>
                );
              })}
          </List>
        </Dropdown.Item>
      </Dropdown>
    </div>
  );
};

export default TypeSeries;
